import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';

export function useDebouncedSearch(setSearch: (value: string) => void, delay: number = 500) {
  const debounced = useMemo(
    () =>
      debounce((value: string) => {
        setSearch(value);
      }, delay),
    [delay]
  );

  useEffect(() => {
    return () => {
      debounced.cancel();
    };
  }, [debounced]);

  return debounced;
}
